import { useCurrentUser, useLocalStorage } from 'javascripts/hooks';

const useShowTaskListTemplateTooltip = () => {
  const currentUser = useCurrentUser();
  const [hasCreatedFirstTaskList, setHasCreatedFirstTaskList] = useLocalStorage(
    `hasCreatedFirstTaskList:${currentUser.id}`,
  );

  const [hasSeenFirstTaskListTooltip, setHasSeenFirstTaskListTooltip] =
    useLocalStorage(`hasShownFirstTaskListTooltip:${currentUser.id}`, false);

  const onTooltipClose = () => {
    setHasSeenFirstTaskListTooltip(true);
  };

  const onTaskListCreate = () => {
    setHasCreatedFirstTaskList(true);
  };

  return {
    onTaskListCreate,
    showTaskListTemplateTooltip:
      hasCreatedFirstTaskList && !hasSeenFirstTaskListTooltip,
    onTooltipClose,
  };
};

export default useShowTaskListTemplateTooltip;
